import { Injectable } from '@angular/core';
import {
  NetworkUtilsService,
  URL_DICT,
} from 'projects/app-core/src/service/network-utils.service';
// import { ExpertRewardsGridRequest } from '../models/expertRewardGridRequest';
import {
  AnyoRewardTypes,
  // ExpertRewardsGridResponse,
  TransactionDirection,
} from '../models/expertRewardGridResponse';
import { ExpertRewardLedgerGridRequest, ExpertRewardLedgerGridResponse } from '../models/ledger/expertLedgerReqRes';

export interface AddOrUpdateRewardsValues {
  name: string;
  value: number;
  description: string;
  active: boolean;
}

export interface AdminGetRewardValuesResponse {
  id: string;
  name: string;
  description: string;
  amount: number;
}
export interface AdminMakePayoutToExpertsRequest {
  amount: number;
  transactionId: string;
  modeOfPayment: string;
  userId: string;
    fromDate: number;
  toDate: number;
}

export interface AdminAddRewardToLedger {
  paymentTransactionType: TransactionDirection;
  postId?: string;
  amount: number;
  userId?: string;
  description: AnyoRewardTypes | string;
  eventId?: string;
  sessionId?: string;
}

export type ConsolidatedRewardCsvRow = Record<string, string | number>;

export interface ConsolidatedRewardExportPayload {
  rows: ConsolidatedRewardCsvRow[];
}

export enum LedgerType {
  SESSION = "session",
  POST = "post",
}

@Injectable({
  providedIn: 'root',
})
export class RewardService {
  constructor(private api: NetworkUtilsService) {}

  public getRewardValues() {
    return this.api.get<AdminGetRewardValuesResponse[]>(
      URL_DICT.adminGetRewardsValues,
    );
  }

  public updateRewardValues(requestBody: AddOrUpdateRewardsValues) {
    return this.api.post(URL_DICT.adminUpdateRewardsValues, requestBody);
  }

  public rewardGrid(requestBody: ExpertRewardLedgerGridRequest) {
    return this.api.post<ExpertRewardLedgerGridResponse>(
      URL_DICT.adminRewardGrid,
      requestBody,
    );
  }

  public makePayout(requestBody: AdminMakePayoutToExpertsRequest) {
    return this.api.post(URL_DICT.adminMakePayment + LedgerType.POST, requestBody);
  }

  public addRewardToLedger(requestBody: AdminAddRewardToLedger) {
    return this.api.post(URL_DICT.addRewardToLedger + LedgerType.POST, requestBody);
  }
  public getAmountForPayment(toDate: number , userId: string) {
    return this.api.post<{amount: number}>(URL_DICT.getAmountForPayment + LedgerType.POST, { toDate , userId});
  }

  public consolidateRewardsExport(fromDate: number, toDate: number) {
    return this.api.post<ConsolidatedRewardExportPayload>(
      URL_DICT.adminConsolidateRewardsExport,
      { fromDate, toDate },
    );
  }
}
